// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__PKyus","mainWrapper":"styles_mainWrapper__EJTWc"};